import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function LuxuryDupesPage() {
  return <SeoArticleLayout article={seoArticles[4]} />;
}